import Vue from 'vue';
import HighchartsVue from 'vue-highcharts';

Vue.use(HighchartsVue);
